import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  FaShieldAlt,
  FaTruckMoving,
  FaShoppingBag,
  FaTools,
  FaUserCog,
  FaBriefcase,
  FaMapMarkedAlt,
  FaBuilding,
  FaMapPin,
  FaLandmark,
  FaFileContract,
  FaLock,
  FaSearch,
  FaStar,
  FaChevronRight
} from "react-icons/fa";

import styles from "./Menu.module.css";

const modulos = [
  { name: "Permisos", icon: FaShieldAlt, path: "/permisos", enabled: true, desc: "Roles y accesos" },
  { name: "Usuarios", icon: FaUserCog, path: "/usuarios", enabled: true, desc: "Cuentas del sistema" },
  { name: "Cargos", icon: FaBriefcase, path: "/cargos", enabled: false, desc: "Estructura organizacional" },
  { name: "Áreas", icon: FaMapMarkedAlt, path: "/areas", enabled: false, desc: "Departamentos" },
  { name: "Clientes", icon: FaBuilding, path: "/clientes", enabled: true, desc: "Base de datos clientes" },
  { name: "Ubicaciones", icon: FaMapPin, path: "/ubicaciones", enabled: true, desc: "Puntos de operación" },
  { name: "Lugares", icon: FaLandmark, path: "/lugares", enabled: true, desc: "Zonas geográficas" },
  { name: "Material", icon: FaFileContract, path: "/material", enabled: true, desc: "Tipos de carga" },
  { name: "Normas", icon: FaFileContract, path: "/normas", enabled: false, desc: "Regulaciones" },
  { name: "Factor de carga", icon: FaTruckMoving, path: "/factores", enabled: true, desc: "Cálculos logísticos" },
  { name: "Dispositivo muestra", icon: FaTools, path: "/dispositivos", enabled: true, desc: "Equipos técnicos" },
  { name: "Tipo Bolsa", icon: FaShoppingBag, path: "/bolsa", enabled: true, desc: "Empaques y contenedores" },
];

const Parametrizacion = () => {
  const navigate = useNavigate();
  const [busqueda, setBusqueda] = useState("");
  const [favoritos, setFavoritos] = useState([]);

  const toggleFav = (name) => {
    setFavoritos((prev) =>
      prev.includes(name)
        ? prev.filter((f) => f !== name)
        : [...prev, name]
    );
  };

  const filtrados = modulos.filter((m) =>
    m.name.toLowerCase().includes(busqueda.toLowerCase())
  );

  return (
    <div className={styles.container}>
      <div className={styles.headerSection}>
        <h1 className={styles.title}>Centro de Configuración</h1>
        <p className={styles.titleDescription}>
          Gestione los parámetros fundamentales del sistema, usuarios, permisos y logística operativa.
        </p>
      </div>

      <div className={styles.searchContainer}>
        <div className={styles.searchBox}>
          <FaSearch className={styles.searchIcon} />
          <input
            placeholder="Buscar módulo de configuración..."
            value={busqueda}
            onChange={(e) => setBusqueda(e.target.value)}
          />
        </div>
      </div>

      <div className={styles.buttonGrid}>
        {filtrados.map((m) => {
          const Icon = m.enabled ? m.icon : FaLock;
          const isFav = favoritos.includes(m.name);

          return (
            <div
              key={m.name}
              className={`${styles.card} ${!m.enabled ? styles.disabled : ""}`}
              onClick={() => m.enabled && navigate(m.path)}
            >
              <div
                className={styles.fav}
                onClick={(e) => {
                  e.stopPropagation();
                  toggleFav(m.name);
                }}
              >
                <FaStar className={isFav ? styles.starOn : styles.starOff} />
              </div>

              <div className={styles.iconContainer}>
                <Icon />
              </div>

              <span className={styles.label}>{m.name}</span>
              <span className={styles.helper}>{m.desc}</span>

              {m.enabled && (
                <div style={{ marginTop: 'auto', paddingTop: '15px', color: 'var(--secondary)', fontSize: '0.75rem', fontWeight: '800', display: 'flex', alignItems: 'center', gap: '5px' }}>
                  CONFIGURAR <FaChevronRight style={{ fontSize: '8px' }} />
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default Parametrizacion;
